<!--
 * @Descripttion: 生成订单-个体户订单-禁止拦截
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="pay-info-confirm">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';

import { XrkTable, XrkTableProps } from 'xrk-components';

import { prohibitList } from '../data-source/apis';
import {
  indexCol,
  entpNameCol,
  individualNameCol,
  operatorCol,
  phoneCol,
  parkNameCol,
  projectNameCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  orderPriceCol
} from '../fields/columns';
const props = withDefaults(
  defineProps<{
    done: any;
    prohibitInterceptCacheKey: string;
  }>(),
  {
    done: () => ({}),
    prohibitInterceptCacheKey: ''
  }
);
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [],
  otherComponents: []
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      indexCol,
      entpNameCol,
      individualNameCol,
      operatorCol,
      phoneCol,
      parkNameCol,
      projectNameCol,
      settlementTaskCountCol,
      taskPriceCol,
      projectPayPriceCol,
      orderPriceCol,
      {
        label: '提示原因',
        prop: 'prohibitInterceptErrorMsgList',
        formatter: ({ cellValue }) => cellValue.join('\n')
      }
    ].filter(Boolean)
  };
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    prohibitInterceptCacheKey: props.prohibitInterceptCacheKey
  };
  const data = await prohibitList(reqData);
  return data;
};
</script>
<style lang="scss"></style>
